import { ICDNAuxMode } from "../enums/icd-aux-mode.enum";

export class ICDAuxCheckboxModel {
  public enabled: boolean = false;
  public mode: ICDNAuxMode = ICDNAuxMode.DISABLED;
  public value: boolean = false;
  public auxId: string = null;
}
